import { CustomerNode } from '@/components/nodes/CustomerNode';
import { JobNode } from '@/components/nodes/JobNode';
import { ChallengeNode } from '@/components/nodes/ChallengeNode';
import { OpportunityNode } from '@/components/nodes/OpportunityNode';
import { CapabilityNode } from '@/components/nodes/CapabilityNode';
import { AssumptionNode } from '@/components/nodes/AssumptionNode';
import { IdeaNode } from '@/components/nodes/IdeaNode';
import { MarketSignalNode } from '@/components/nodes/MarketSignalNode';

export const nodeTypes = {
  customer: CustomerNode,
  job: JobNode,
  challenge: ChallengeNode,
  opportunity: OpportunityNode,
  capability: CapabilityNode,
  assumption: AssumptionNode,
  idea: IdeaNode,
  market_signal: MarketSignalNode,
};

export const NODE_TYPE_META = {
  customer: { label: 'Customer', side: 'customer', color: 'orange' },
  job: { label: 'Job', side: 'customer', color: 'blue' },
  challenge: { label: 'Challenge', side: 'customer', color: 'red' },
  opportunity: { label: 'Opportunity', side: 'customer', color: 'green' },
  capability: { label: 'Capability', side: 'capability', color: 'purple' },
  assumption: { label: 'Assumption', side: 'meta', color: 'yellow' },
  // The seed of the journey graph: every other typed node ladders
  // evidence toward it via incoming edges (market_signal, assumption,
  // etc.). Topologically a DAG sink (no outgoing edges) even though
  // semantically it's the root concept everything else hangs off.
  // `side: 'root'` is a new layer used by downstream layout/filter
  // consumers; AddNodeButton intentionally omits 'idea' since the
  // journey form is the only writer for this node type.
  idea: { label: 'Idea', side: 'root', color: 'pink' },
  // Market research finding. Evidence overlay (like assumption) — attaches to
  // idea / job / challenge / opportunity via 'evidences' edges. Created by the
  // market research flow, not the generic Add Node menu.
  market_signal: { label: 'Market finding', side: 'meta', color: 'teal' },
} as const;
